import IRepositoryWrapper from "./IRepositoryWrapper";
import { singleton } from "tsyringe";
import { environment } from "@/environment/environment";
import IFoodRepository from "../Food/IFoodRepository";
import FoodRepository from "../Food/FoodRepository";

@singleton()
export default class RepositoryWrapper implements IRepositoryWrapper {
  private baseUrl = environment.baseUrl;
  private defaultHeaders: any = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };
  Food: IFoodRepository;

  constructor() {
    this.Food = new FoodRepository(this.baseUrl, this.defaultHeaders, "food");
  }

  SetValueToHeader(key: string, value: string) {
    this.defaultHeaders[key] = value;
  }

}
